var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8867 73.5342H16.918V36.4248H79.2617V63.1436H76.293V39.3936H19.8867V73.5342Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M79.2617 51.2686H16.918V36.4248H79.2617V51.2686ZM19.8867 48.2998H76.293V39.3936H19.8867V48.2998Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.918 42.3623H79.2617V45.3311H16.918V42.3623Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.3242 33.4561H22.8555V21.5811H73.3242V33.4561ZM25.8242 30.4873H70.3555V24.5498H25.8242V30.4873Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.07422 91.3467H94.1055V94.3154H2.07422V91.3467Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M34.7305 94.3154H10.9805V70.5654H34.7305V94.3154ZM13.9492 91.3467H31.7617V73.5342H13.9492V91.3467Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.3086 86.8936H28.793V88.3779H27.3086V86.8936Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.3398 86.8936H25.8242V88.3779H24.3398V86.8936Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M83.7148 94.3154C82.5405 94.3154 81.3926 93.9672 80.4161 93.3148C79.4397 92.6624 78.6787 91.7351 78.2293 90.6501C77.7799 89.5652 77.6623 88.3713 77.8914 87.2196C78.1205 86.0678 78.686 85.0099 79.5164 84.1795C80.3468 83.3491 81.4047 82.7836 82.5565 82.5545C83.7083 82.3254 84.9021 82.443 85.987 82.8924C87.072 83.3418 87.9993 84.1028 88.6517 85.0792C89.3041 86.0556 89.6523 87.2036 89.6523 88.3779C89.6523 89.9527 89.0268 91.4629 87.9133 92.5764C86.7998 93.6899 85.2896 94.3154 83.7148 94.3154ZM83.7148 85.4092C83.1277 85.4092 82.5537 85.5833 82.0655 85.9095C81.5773 86.2357 81.1968 86.6994 80.9721 87.2418C80.7474 87.7843 80.6886 88.3812 80.8031 88.9571C80.9177 89.533 81.2004 90.062 81.6156 90.4772C82.0308 90.8923 82.5598 91.1751 83.1357 91.2896C83.7116 91.4042 84.3085 91.3454 84.8509 91.1207C85.3934 90.896 85.8571 90.5155 86.1833 90.0273C86.5095 89.5391 86.6836 88.9651 86.6836 88.3779C86.6836 87.5906 86.3708 86.8355 85.8141 86.2787C85.2573 85.722 84.5022 85.4092 83.7148 85.4092Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M55.5117 94.3154C54.3374 94.3154 53.1894 93.9672 52.213 93.3148C51.2366 92.6624 50.4756 91.7351 50.0262 90.6501C49.5768 89.5652 49.4592 88.3713 49.6883 87.2196C49.9174 86.0678 50.4829 85.0099 51.3133 84.1795C52.1437 83.3491 53.2016 82.7836 54.3534 82.5545C55.5051 82.3254 56.699 82.443 57.7839 82.8924C58.8688 83.3418 59.7962 84.1028 60.4486 85.0792C61.101 86.0556 61.4492 87.2036 61.4492 88.3779C61.4492 89.9527 60.8237 91.4629 59.7102 92.5764C58.5967 93.6899 57.0864 94.3154 55.5117 94.3154ZM55.5117 85.4092C54.9246 85.4092 54.3506 85.5833 53.8624 85.9095C53.3742 86.2357 52.9937 86.6994 52.769 87.2418C52.5443 87.7843 52.4855 88.3812 52.6 88.9571C52.7146 89.533 52.9973 90.062 53.4125 90.4772C53.8277 90.8923 54.3567 91.1751 54.9325 91.2896C55.5084 91.4042 56.1053 91.3454 56.6478 91.1207C57.1903 90.896 57.6539 90.5155 57.9802 90.0273C58.3064 89.5391 58.4805 88.9651 58.4805 88.3779C58.4805 87.5906 58.1677 86.8355 57.6109 86.2787C57.0542 85.722 56.2991 85.4092 55.5117 85.4092Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M73.3242 79.4717H49.5742V55.7217H73.3242V79.4717ZM52.543 76.5029H70.3555V58.6904H52.543V76.5029Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M65.9023 72.0498H67.3867V73.5342H65.9023V72.0498Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M62.9336 72.0498H64.418V73.5342H62.9336V72.0498Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M27.3086 80.9561H18.4023V70.5654H27.3086V80.9561ZM21.3711 77.9873H24.3398V73.5342H21.3711V77.9873Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M65.9023 66.1123H56.9961V55.7217H65.9023V66.1123ZM59.9648 63.1436H62.9336V58.6904H59.9648V63.1436Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M90.5875 77.9873H80.7461C80.3524 77.9873 79.9749 77.8309 79.6965 77.5525C79.4181 77.2742 79.2617 76.8966 79.2617 76.5029V70.5654C79.2617 70.1717 79.4181 69.7942 79.6965 69.5158C79.9749 69.2374 80.3524 69.0811 80.7461 69.0811H88.3609C88.6631 69.0808 88.9582 69.1727 89.2067 69.3446C89.4553 69.5164 89.6454 69.7601 89.7518 70.0429L91.9784 75.9804C92.0629 76.2052 92.0916 76.447 92.0621 76.6853C92.0326 76.9236 91.9458 77.1511 91.809 77.3485C91.6722 77.5458 91.4897 77.707 91.2769 77.8183C91.0642 77.9295 90.8276 77.9875 90.5875 77.9873ZM82.2305 75.0186H88.4455L87.3323 72.0498H82.2305V75.0186Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M92.6211 89.8623H88.168V86.8936H89.6523V78.2575L85.6549 67.5967H77.7773V79.4717H48.0898V86.8936H51.0586V89.8623H45.1211V76.5029H74.8086V64.6279H87.7123L92.6211 77.7171V89.8623Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M59.9648 86.8936H79.2617V89.8623H59.9648V86.8936Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M55.5117 89.8623C56.3315 89.8623 56.9961 89.1977 56.9961 88.3779C56.9961 87.5581 56.3315 86.8936 55.5117 86.8936C54.6919 86.8936 54.0273 87.5581 54.0273 88.3779C54.0273 89.1977 54.6919 89.8623 55.5117 89.8623Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M83.7148 89.8623C84.5346 89.8623 85.1992 89.1977 85.1992 88.3779C85.1992 87.5581 84.5346 86.8936 83.7148 86.8936C82.895 86.8936 82.2305 87.5581 82.2305 88.3779C82.2305 89.1977 82.895 89.8623 83.7148 89.8623Z",
    fill: "#10417A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M85.1992 63.1437V23.9829L48.078 5.42229L9.49609 23.9978V92.8312C9.49609 93.2249 9.3397 93.6024 9.06133 93.8808C8.78296 94.1592 8.4054 94.3156 8.01172 94.3156C7.61804 94.3156 7.24048 94.1592 6.96211 93.8808C6.68373 93.6024 6.52734 93.2249 6.52734 92.8312V23.0656C6.5276 22.7864 6.60656 22.513 6.75517 22.2767C6.90378 22.0404 7.11601 21.8508 7.3675 21.7296L47.4456 2.43276C47.6499 2.33452 47.874 2.28438 48.1007 2.28618C48.3274 2.28798 48.5506 2.34168 48.7534 2.44315L87.3471 21.74C87.5934 21.8631 87.8006 22.0523 87.9456 22.2864C88.0906 22.5204 88.1675 22.7902 88.168 23.0656V63.1437H85.1992Z",
    fill: "#10417A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.d3fc8169e1dc22855826018b9e18d1f6.svg";
export { ForwardRef as ReactComponent };